import PropTypes from "prop-types"
import React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "src/components/Select"

export const STATUS_OPTIONS = [
  { value: "active", label: "Active items" },
  { value: "inactive", label: "Inactive items" },
  { value: "all", label: "All items" },
]

const StatusFilter = ({ value, onChange }) => {
  const selected =
    STATUS_OPTIONS.find((option) => option.value === value) || STATUS_OPTIONS[0]

  return (
    <Select value={value} onValueChange={(next) => onChange(next || "active")}>
      <SelectTrigger variant="button" className="w-auto" aria-label="Status">
        {selected.label}
      </SelectTrigger>
      <SelectContent className="max-h-none">
        {STATUS_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

StatusFilter.propTypes = {
  value: PropTypes.oneOf(["active", "inactive", "all"]).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default StatusFilter
